import React from 'react'
import { useNavigate } from 'react-router-dom';
import ButtonWhiteReturn from '../Buttons/ButtonWhiteReturn';

const NavbarReturnBody = ({ title, returnTo, iconOrText, icon, alingment }) => {
    const navigate = useNavigate();
    return (
        <div>
            <ButtonWhiteReturn
                title={title}
                icon={icon}
                onClick={() => navigate(returnTo)}
                iconOrText={iconOrText}
                alingment={alingment}
            />
        </div>
    )
}

export default NavbarReturnBody